var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBsc = function SvgBsc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 23",
    fill: "#F5B826",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m15.977 13.336 2.602 2.596L11.505 23l-7.069-7.068 2.603-2.596 4.466 4.466 4.473-4.466Zm-4.473-4.473 2.64 2.64-2.64 2.641-2.633-2.633v-.007l.464-.464.224-.224 1.945-1.953Zm-8.901.038 2.603 2.603-2.603 2.595L0 11.496l2.603-2.595Zm17.801 0 2.604 2.603-2.604 2.595-2.602-2.603 2.602-2.595ZM11.504 0l7.068 7.068-2.603 2.603-4.465-4.473-4.466 4.466-2.603-2.596L11.504 0Z"
  })));
};

export default SvgBsc;